<template>
  <p :class="['terms', { '--centered': centered }]">
    <span>{{ `${$t('terms.0')} ` }}</span>
    <LangRouterLink :to="{ name: ROUTES.TERMS.PRIVACY }">{{ $t('pages.privacy') }}</LangRouterLink>
    <span>{{ ` ${$t('terms.1')} ` }}</span>
    <LangRouterLink :to="{ name: ROUTES.TERMS.TERMS }">{{ $t('pages.terms') }}</LangRouterLink>
    <span>.</span>
  </p>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { UsesRoutesMixin } from '@/mixins'

export default {
  name: 'TermsBlock',
  mixins: [UsesRoutesMixin],
  components: { LangRouterLink },
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
